import React, { useEffect } from 'react';
import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let payoutPageMachine: any;

export const useSMPayoutGetContent = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  payoutPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(payoutPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    payoutPageMachine,
    payoutPageState: state,
    payoutPageSend: send,
  };
};
